const update=(oldObject,newObject)=>{
    return {
        ...oldObject,
        ...newObject
    }
}

export default update;